// src/docs/DocsDashboard.js
import React from "react";
import { Container, Typography } from "@mui/material";

const DocsDashboard = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 2 }}>
        Dashboard Overview
      </Typography>

      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 2 }}>
        The Dashboard is your central hub on CrowdLaunch where you can monitor your stake, share balances, and Top Preforming Projects. It serves as the starting point for all your activities on the platform.
      </Typography>

      {/* Key Sections */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Key Sections of the Dashboard
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        • <strong>Main Navigation:</strong> Use the side menu to quickly access features such as tokenization, project financing, staking, and more.
        <br />• <strong>Project Metrics:</strong> View real-time performance data on your stake, including total earned, Total yield, and current status.
        <br />• <strong>Wallet Overview:</strong> Keep track of your LNCH and other token balances directly from the dashboard.
        <br />• <strong>Top Projects :</strong> Keep track of your the top performing projects directly from the dashboard.
        <br />• <strong>Recent Projects :</strong> Keep track of your the newest projects that have been created.


      </Typography>

    
      {/* Troubleshooting & Tips */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Troubleshooting & Tips
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        • If certain metrics are not updating, try refreshing the page.
        <br />• Make sure your wallet is connected and you’re on the correct network.
        <br />• Hover over dashboard elements to see additional tooltips and explanations.
        <br />• Refresh page, or try disconnecting and reconnecting your wallet. 

      </Typography>

      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        The Dashboard is your command center for navigating CrowdLaunch. By familiarizing yourself with its features, you can manage your stake and investments with confidence and ease.
      </Typography>
    </Container>
  );
};

export default DocsDashboard;
